import React from "react";
import "./ProductCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

export default function ProductCard({ title, image, onClick }) {
  return (
    <div className="product-card" onClick={onClick}>
      <div className="product-image">
        <img src={image} alt={title} />
      </div>

      <div className="product-footer">
        <p className="product-title">{title}</p>
        <div className="arrow-btn">
          <FontAwesomeIcon icon={faAngleRight} />
        </div>
      </div>
    </div>
  );
}
